import { getLocale } from 'utils';

export const getDate = (date: Date, locale: string) => {
  const isoLocale = getLocale(locale);
  const dtf = Intl.DateTimeFormat(isoLocale, { day: 'numeric', month: 'long' });

  return `${dtf.format(date)} ${date.getFullYear()}`;
};
